// Auth state management — module-level singleton.
// Persists the admin secret in sessionStorage (cleared when tab closes).

const STORAGE_KEY = "news_editing_admin_secret";

function loadSecret(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function saveSecret(secret: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, secret);
  } catch { /* noop */ }
}

function clearSecret(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch { /* noop */ }
}

let _secret: string | null = loadSecret();

export function getAdminSecret(): string | null {
  return _secret;
}

export function setAdminSecret(secret: string): void {
  _secret = secret;
  saveSecret(secret);
}

export function clearAdminSecret(): void {
  _secret = null;
  clearSecret();
}

export function isAuthenticated(): boolean {
  return _secret !== null && _secret.length > 0;
}

export async function verifySecret(secret: string): Promise<boolean> {
  try {
    const res = await fetch("/api/auth/verify", {
      headers: {
        "Content-Type": "application/json",
        "X-Admin-Secret": secret,
      },
    });
    const data = await res.json() as { success: boolean };
    return data.success === true;
  } catch {
    return false;
  }
}